/* eslint-disable max-len */
module.exports = {
    "en": {
        "ok": "ok",
        "balance": "balance",
        "win": "win",
        "bet": "bet",
        "bet-amount": "Bet Amount",
        "autoplay": "Autoplay",
        "spins": "spins",
        "sound": "sound",
        "pricelist": "Price list",
        "game-rules": "game rules",
        "keyboard": "keyboard",
        "paytable": "paytable",
        "history": "play history",
        "settings": "Settings",
        "on": "on",
        "off": "off",
        "start": "start",
        "back": "back",
        "sound-settings": "Sound Settings",
        "game-volume": "Volume",
        "music": "music",
        "sound-effects": "sound effects",
        "date": "date & time",
        "confirm": "confirm",
        "close-game": "close the game",
        "close": "close",
        "realityCheckContent": "You have been playing this amount of time {0}",
        "reality": "reality check",
        "balanceChange": "balance difference",
        "roundId": "round ID",
        "loss-limit": "loss limit",
        "single-win-limit": "single win limit",
        "loss-limit-popup": "Autoplay stopped as you lost more than loss limit",
        "win-limit-popup": "Autoplay stopped as you won more than the single win limit",
        "paytableTitle": "PAYTABLE",
        "pricelistTitle": "PRICE LIST",
        "paylinesTitle": "PAY LINES",
        "paylinesContent": "The paytable reflects the current payout configuration. Paylines pay from left to right.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "With All Ways, there are no fixed pay lines - symbols just need to land on adjacent reels to generate wins. Wins per way are calculated based on the longest combination from left to right.",
        "fun-mode": "FUN MODE",
        "required": "required",
        "accept": "accept",
        "reject": "reject",
        "free-spins": "Free spins",
        "super-free-spins": "Super free spins",
        "leave-game": "leave game",
        "relaunch": "restart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max win {1}x",
        "net-position": "Net position:"
    },
    "zz": {
        "ok": "gerai",
        "balance": "stanje računa",
        "win": "nyeremény",
        "bet": "statymas",
        "bet-amount": "Montante da Aposta",
        "autoplay": "Automatické přehrávání",
        "spins": "pyöräytykset",
        "sound": "geluid",
        "pricelist": "Listă de prețuri",
        "game-rules": "κανόνες παιχνιδιού",
        "keyboard": "πληκτρολόγιο",
        "paytable": "tabella dei pagamenti",
        "history": "cronologia di gioco",
        "settings": "Játékbeállítások",
        "on": "uključi",
        "off": "isključi",
        "start": "käynnistä",
        "back": "tillbaka",
        "sound-settings": "Geluidsinstellingen",
        "game-volume": "Äänenvoimakkuus",
        "music": "musiikki",
        "sound-effects": "звуковые эффекты",
        "date": "datum und Uhrzeit",
        "confirm": "подтвердить",
        "close-game": "κλείσιμο παιχνιδιού",
        "close": "schließen",
        "realityCheckContent": "Grasz przez następującą ilość czasu {0}",
        "reality": "έλεγχος πραγματικότητας",
        "balanceChange": "kontostand-Differenz",
        "roundId": "kierroksen ID",
        "loss-limit": "ograničenje gubitka",
        "single-win-limit": "ograničenje dobitka pojedinačne igre",
        "loss-limit-popup": "Automatinis paleidimas sustabdytas, nes Jūs praradote daugiau nei praradimo limitas",
        "win-limit-popup": "Auto-igra je zaustavljena jer ste dobili više od iznosa ograničenja dobitka pojedinačne igre",
        "paytableTitle": "TABELLA DEI PAGAMENTI",
        "pricelistTitle": "LISTĂ DE PREȚURI",
        "paylinesTitle": "LINHAS DE PAGAMENTO",
        "paylinesContent": "Ο Πίνακας Πληρωμών αντανακλά την τρέχουσα διαμόρφωση πληρωμών. Οι γραμμές πληρωμής (paylines) πληρώνουν από αριστερά προς τα δεξιά.",
        "allwaysTitle": "ВЫИГРЫШ ВО ВСЕХ НАПРАВЛЕНИЯХ",
        "allwaysContent": "W grze wszystkie kombinacje dają wygraną. Oznacza to, że nie ma stałych linii wypłat. Aby otrzymać wygraną, należy trafić takie same symbole na sąsiadujących rolkach. Wygrane z kombinacji obliczane są na podstawie najdłuższej wygrywającej kombinacji liczonej od lewej do prawej strony.",
        "fun-mode": "GIOCA PER DIVERTIMENTO",
        "required": "erforderlich",
        "accept": "akzeptieren",
        "reject": "отказаться",
        "free-spins": "Ingyenes Pörgetések",
        "super-free-spins": "Σούπερ δωρεάν περιστροφές",
        "leave-game": "kilépés a játékból",
        "relaunch": "käynnistä uudelleen",
        "id": "kimlik",
        "rtp-and-maxwin": "Palautusprosentti {0}%, Maksimivoitto {1}x",
        "net-position": "Posição de Internet:"
    },
    "ca": {
        "ok": "ok",
        "balance": "balance",
        "win": "win",
        "bet": "bet",
        "bet-amount": "Bet Amount",
        "autoplay": "Autoplay",
        "spins": "spins",
        "sound": "sound",
        "pricelist": "Price list",
        "game-rules": "game rules",
        "keyboard": "keyboard",
        "paytable": "paytable",
        "history": "play history",
        "settings": "Settings",
        "on": "on",
        "off": "off",
        "start": "start",
        "back": "back",
        "sound-settings": "Sound Settings",
        "game-volume": "Volume",
        "music": "music",
        "sound-effects": "sound effects",
        "date": "date & time",
        "confirm": "confirm",
        "close-game": "close the game",
        "close": "close",
        "realityCheckContent": "You have been playing this amount of time {0}",
        "reality": "reality check",
        "balanceChange": "balance difference",
        "roundId": "round ID",
        "loss-limit": "loss limit",
        "single-win-limit": "single win limit",
        "loss-limit-popup": "Autoplay stopped as you lost more than loss limit",
        "win-limit-popup": "Autoplay stopped as you won more than the single win limit",
        "paytableTitle": "PAYTABLE",
        "pricelistTitle": "PRICE LIST",
        "paylinesTitle": "PAY LINES",
        "paylinesContent": "The paytable reflects the current payout configuration. Paylines pay from left to right.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "With All Ways, there are no fixed pay lines - symbols just need to land on adjacent reels to generate wins. Wins per way are calculated based on the longest combination from left to right.",
        "fun-mode": "FUN MODE",
        "required": "required",
        "accept": "accept",
        "reject": "reject",
        "free-spins": "Free spins",
        "super-free-spins": "Super free spins",
        "leave-game": "leave game",
        "relaunch": "restart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max win {1}x",
        "net-position": "Net position:"
    },
    "en-us": {
        "ok": "ok",
        "balance": "balance",
        "win": "win",
        "bet": "bet",
        "bet-amount": "Bet Amount",
        "autoplay": "Autoplay",
        "spins": "spins",
        "sound": "sound",
        "pricelist": "Price list",
        "game-rules": "game rules",
        "keyboard": "keyboard",
        "paytable": "paytable",
        "history": "play history",
        "settings": "Settings",
        "on": "on",
        "off": "off",
        "start": "start",
        "back": "back",
        "sound-settings": "Sound Settings",
        "game-volume": "Volume",
        "music": "music",
        "sound-effects": "sound effects",
        "date": "date & time",
        "confirm": "confirm",
        "close-game": "close the game",
        "close": "close",
        "realityCheckContent": "You have been playing this amount of time {0}",
        "reality": "reality check",
        "balanceChange": "balance difference",
        "roundId": "round ID",
        "loss-limit": "loss limit",
        "single-win-limit": "single win limit",
        "loss-limit-popup": "Autoplay stopped as you lost more than loss limit",
        "win-limit-popup": "Autoplay stopped as you won more than the single win limit",
        "paytableTitle": "PAYTABLE",
        "pricelistTitle": "PRICE LIST",
        "paylinesTitle": "PAY LINES",
        "paylinesContent": "The paytable reflects the current payout configuration. Paylines pay from left to right.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "With All Ways, there are no fixed pay lines - symbols just need to land on adjacent reels to generate wins. Wins per way are calculated based on the longest combination from left to right.",
        "fun-mode": "FUN MODE",
        "required": "required",
        "accept": "accept",
        "reject": "reject",
        "free-spins": "Free spins",
        "super-free-spins": "Super free spins",
        "leave-game": "leave game",
        "relaunch": "restart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max win {1}x",
        "net-position": "Net position:"
    },
    "es-co": {
        "ok": "ok",
        "balance": "saldo",
        "win": "ganancia",
        "bet": "apuesta",
        "bet-amount": "Valor de apuesta",
        "autoplay": "Auto-spin",
        "spins": "spins",
        "sound": "sonido",
        "pricelist": "lista de precios",
        "game-rules": "reglas de juego",
        "keyboard": "teclado",
        "paytable": "tabla de pago",
        "history": "historial de juego",
        "settings": "Ajustes",
        "on": "on",
        "off": "off",
        "start": "iniciar",
        "back": "atras",
        "sound-settings": "Ajustes de sonido",
        "game-volume": "Volumen",
        "music": "música",
        "sound-effects": "efectos de sonido",
        "date": "fecha y hora",
        "confirm": "confirmar",
        "close-game": "cerrar juego",
        "close": "cerrar",
        "realityCheckContent": "Has estado jugando durante tanto tiempo {0}",
        "reality": "reality check",
        "balanceChange": "diferencia de saldo",
        "roundId": "ID de ronda",
        "loss-limit": "límite de pérdida",
        "single-win-limit": "límite de ganancia única",
        "loss-limit-popup": "La reproducción automática se detuvo al perder más del límite de pérdida",
        "win-limit-popup": "La reproducción automática se detuvo al ganar más del límite de ganancia única",
        "paytableTitle": "TABLA DE PAGO",
        "pricelistTitle": "LISTA DE PRECIOS",
        "paylinesTitle": "LÍNEAS DE PAGO",
        "paylinesContent": "La tabla de pagos refleja la configuración de pago actual. Las líneas de pago cuentan de izquierda a derecha.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Con All Ways, no hay líneas de pago fijas. Solo se necesita que los símbolos caigan en los carretes adyacentes para generar ganancias. Las ganancias por Way se calculan en función de la combinación más larga de izquierda a derecha.",
        "fun-mode": "MODO DIVERSIÓN",
        "required": "necesario",
        "accept": "aceptar",
        "reject": "rechazar",
        "free-spins": "Giros gratis",
        "super-free-spins": "Giros súper gratis",
        "leave-game": "salir del juego",
        "relaunch": "reiniciar",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}, Ganancia Máxima {1}x",
        "net-position": "Posición neta:"
    },
    "es": {
        "ok": "ok",
        "balance": "saldo",
        "win": "ganancia",
        "bet": "apuesta",
        "bet-amount": "Valor de apuesta",
        "autoplay": "Auto-spin",
        "spins": "spins",
        "sound": "sonido",
        "pricelist": "lista de precios",
        "game-rules": "reglas de juego",
        "keyboard": "teclado",
        "paytable": "tabla de pago",
        "history": "historial de juego",
        "settings": "Ajustes",
        "on": "on",
        "off": "off",
        "start": "iniciar",
        "back": "atras",
        "sound-settings": "Ajustes de sonido",
        "game-volume": "Volumen",
        "music": "música",
        "sound-effects": "efectos de sonido",
        "date": "fecha y hora",
        "confirm": "confirmar",
        "close-game": "cerrar juego",
        "close": "cerrar",
        "realityCheckContent": "Has estado jugando durante tanto tiempo {0}",
        "reality": "reality check",
        "balanceChange": "diferencia de saldo",
        "roundId": "ID de ronda",
        "loss-limit": "límite de pérdida",
        "single-win-limit": "límite de ganancia única",
        "loss-limit-popup": "La reproducción automática se detuvo al perder más del límite de pérdida",
        "win-limit-popup": "La reproducción automática se detuvo al ganar más del límite de ganancia única",
        "paytableTitle": "TABLA DE PAGO",
        "pricelistTitle": "LISTA DE PRECIOS",
        "paylinesTitle": "LÍNEAS DE PAGO",
        "paylinesContent": "La tabla de pagos refleja la configuración de pago actual. Las líneas de pago cuentan de izquierda a derecha.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Con All Ways, no hay líneas de pago fijas. Solo se necesita que los símbolos caigan en los carretes adyacentes para generar ganancias. Las ganancias por Way se calculan en función de la combinación más larga de izquierda a derecha.",
        "fun-mode": "MODO DIVERSIÓN",
        "required": "necesario",
        "accept": "aceptar",
        "reject": "rechazar",
        "free-spins": "Giros gratis",
        "super-free-spins": "Giros súper gratis",
        "leave-game": "salir del juego",
        "relaunch": "reiniciar",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}, Ganancia Máxima {1}x",
        "net-position": "Posición neta:"
    },
    "de": {
        "ok": "ok",
        "balance": "guthaben",
        "win": "gewinn",
        "bet": "einsatz",
        "bet-amount": "Einsatzhöhe",
        "autoplay": "Autospiel",
        "spins": "drehs",
        "sound": "ton",
        "pricelist": "Preisliste",
        "game-rules": "spielregeln",
        "keyboard": "tastatur",
        "paytable": "gewinntabelle",
        "history": "spielverlauf",
        "settings": "Einstellungen",
        "on": "an",
        "off": "aus",
        "start": "starten",
        "back": "zurück",
        "sound-settings": "Ton-Einstellungen",
        "game-volume": "Lautstärke",
        "music": "musik",
        "sound-effects": "soundeffekte",
        "date": "datum und Uhrzeit",
        "confirm": "bestätigen",
        "close-game": "spiel schließen",
        "close": "schließen",
        "realityCheckContent": "Sie haben so lange gespielt {0}.",
        "reality": "realitätsprüfung",
        "balanceChange": "kontostand-Differenz",
        "roundId": "runden-ID",
        "loss-limit": "verlustlimit",
        "single-win-limit": "gewinnlimit",
        "loss-limit-popup": "Das Autospiel wurde gestoppt, da Sie mehr als das Verlustlimit verloren haben",
        "win-limit-popup": "Autospiel wurde gestoppt, da Sie mehr als das Einzelgewinnlimit gewonnen haben",
        "paytableTitle": "AUSZAHLUNGSTABELLE",
        "pricelistTitle": "PREISLISTE",
        "paylinesTitle": "GEWINNLINIEN",
        "paylinesContent": "Die Auszahlungstabelle spiegelt die aktuelle Auszahlungskonfiguration wider. Gewinnlinien werden von links nach rechts ausgezahlt.",
        "allwaysTitle": "ALLE WEGE",
        "allwaysContent": "Bei \"Alle Wege\" gibt es keine festen Gewinnlinien - die Symbole müssen nur auf benachbarten Rollen landen, um Gewinne zu erzielen. Gewinne pro Weg werden auf der Grundlage der längsten Kombination von ganz links nach rechts berechnet.",
        "fun-mode": "SPASSMODUS",
        "required": "erforderlich",
        "accept": "akzeptieren",
        "reject": "ablehnen",
        "free-spins": "Freispiele",
        "super-free-spins": "Super freispiele",
        "leave-game": "Spiel verlassen",
        "relaunch": "neu starten",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max Gewinn {1}x",
        "net-position": "Nettoposition:"
    },
    "hr": {
        "ok": "ok",
        "balance": "stanje računa",
        "win": "dobitak",
        "bet": "oklada",
        "bet-amount": "Ulog",
        "autoplay": "Auto-igra",
        "spins": "vrtnje",
        "sound": "zvuk",
        "pricelist": "Cjenik",
        "game-rules": "pravila igre",
        "keyboard": "tipkovnica",
        "paytable": "tablica isplate",
        "history": "povijest igre",
        "settings": "Postavke",
        "on": "uključi",
        "off": "isključi",
        "start": "start",
        "back": "natrag",
        "sound-settings": "Postavke Zvuka",
        "game-volume": "Razina Zvuka",
        "music": "glazba",
        "sound-effects": "zvučni efekti",
        "date": "datum i vrijeme",
        "confirm": "potvrdi",
        "close-game": "završi igru",
        "close": "zatvoriti",
        "realityCheckContent": "Vrijeme provedeno u igri {0}.",
        "reality": "provjera stanja",
        "balanceChange": "promjena stanja",
        "roundId": "ID runde",
        "loss-limit": "ograničenje gubitka",
        "single-win-limit": "ograničenje dobitka pojedinačne igre",
        "loss-limit-popup": "Auto-igra je zaustavljena jer ste izgubili više od iznosa ograničenja gubitka",
        "win-limit-popup": "Auto-igra je zaustavljena jer ste dobili više od iznosa ograničenja dobitka pojedinačne igre",
        "paytableTitle": "TABLICA ISPLATE",
        "pricelistTitle": "CJENIK",
        "paylinesTitle": "LINIJE ISPLATE",
        "paylinesContent": "Tablica isplate odražava trenutnu konfiguraciju isplate. Linije isplate se vrše s lijeve na desnu stranu.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Uz All Ways, ne postoje fiksne platne linije - simboli se trebaju samo spustiti na susjedne valjke da biste ostvarili dobitak. Pobjede se izračunavaju na temelju najdulje kombinacije s lijeva na desno.",
        "fun-mode": "IGRANJE IZ ZABAVE",
        "required": "potrebno",
        "accept": "prihvati",
        "reject": "odbaci",
        "free-spins": "Besplatne vrtnje",
        "super-free-spins": "Super besplatne vrtnje",
        "leave-game": "Izlaz",
        "relaunch": "ponovo pokreni",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Maksimalni profit {1} x",
        "net-position": "Neto pozicija:"
    },
    "sv": {
        "ok": "ok",
        "balance": "saldo",
        "win": "vinst",
        "bet": "insats",
        "bet-amount": "Insats per spin",
        "autoplay": "Autospinn",
        "spins": "spins",
        "sound": "ljud",
        "pricelist": "Prislista",
        "game-rules": "spelregler",
        "keyboard": "tangentbord",
        "paytable": "vinsttabell",
        "history": "spelhistorik",
        "settings": "Inställningar",
        "on": "på",
        "off": "av",
        "start": "starta",
        "back": "tillbaka",
        "sound-settings": "Ljudinställningar",
        "game-volume": "Volym",
        "music": "musik",
        "sound-effects": "ljudeffekter",
        "date": "datum & tid",
        "confirm": "bekräfta",
        "close-game": "stäng spelet",
        "close": "stäng",
        "realityCheckContent": "Du har spelat så här länge {0}.",
        "reality": "verklighetskontroll",
        "balanceChange": "balansskillnad",
        "roundId": "runda ID",
        "loss-limit": "förlustgräns",
        "single-win-limit": "enkelvinstbegränsning",
        "loss-limit-popup": "Autoplay har stoppats eftersom du förlorade mer än förlustgränsen",
        "win-limit-popup": "Autoplay har stoppats eftersom du vann mer än vinstgränsen",
        "paytableTitle": "VINSTTABELL",
        "pricelistTitle": "PRISLISTA",
        "paylinesTitle": "BETALLINJER",
        "paylinesContent": "Vinsttabellen återspeglar den aktuella vinstkonfigurationen. Vinstlinjer betalar från vänster till höger.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Med All Ways finns det inga fasta betallinjer - du behöver endast landa symboler på angränsande rullar för att vinna. Vinsten beräknas på den längsta kombinationen per Way från vänster till höger.",
        "fun-mode": "FUN MODE",
        "required": "nödvändig",
        "accept": "acceptera",
        "reject": "avvisa",
        "free-spins": "Free spins",
        "super-free-spins": "Super free spins",
        "leave-game": "Avsluta spelet",
        "relaunch": "omstart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max vinst {1}x",
        "net-position": "Nettoposition:"
    },
    "ro": {
        "ok": "ok",
        "balance": "sold",
        "win": "câștig",
        "bet": "pariu",
        "bet-amount": "Sumă Pariu",
        "autoplay": "Joc automat",
        "spins": "rotiri",
        "sound": "sunet",
        "pricelist": "Listă de prețuri",
        "game-rules": "reguli de joc",
        "keyboard": "tastatură",
        "paytable": "tabel de plăți",
        "history": "istoric joc",
        "settings": "Setări",
        "on": "pornit",
        "off": "oprit",
        "start": "start",
        "back": "înapoi",
        "sound-settings": "Setări sunet",
        "game-volume": "Volum",
        "music": "muzică",
        "sound-effects": "efecte sonore",
        "date": "dată & timp",
        "confirm": "confirmare",
        "close-game": "închiderea jocului",
        "close": "închidere",
        "realityCheckContent": "Ați jucat această perioadă de timp {0}",
        "reality": "analiză a situației",
        "balanceChange": "diferența de sold",
        "roundId": "ID rundă",
        "loss-limit": "limită de pierdere",
        "single-win-limit": "limită câștig unic",
        "loss-limit-popup": "Jocul automat s-a oprit deoarece ați pierdut mai mult decât limita de pierdere",
        "win-limit-popup": "Jocul automat s-a oprit deoarece ați pierdut mai mult decât limita de pierdere",
        "paytableTitle": "TABEL DE PLĂȚI",
        "pricelistTitle": "LISTĂ DE PREȚURI",
        "paylinesTitle": "LINII DE PLATĂ",
        "paylinesContent": "Tabelul de plăți reflectă configurația curentă de plată. Liniile de plată plătesc de la stânga la dreapta.",
        "allwaysTitle": "TOATE SENSURILE",
        "allwaysContent": "Cu Toate Sensurile nu există linii de plată fixe - simbolurile trebuie doar să aterizeze pe role adiacente pentru a genera câștiguri. Câștigurile per sens sunt calculate pe baza celei mai lungi combinații de la stânga la dreapta.",
        "fun-mode": "MOD DISTRACTIV",
        "required": "necesar",
        "accept": "accept",
        "reject": "respinge",
        "free-spins": "Free Spins",
        "super-free-spins": "Super rotiri gratuite",
        "leave-game": "părăsiți jocul",
        "relaunch": "repornire",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Câștig max {1}x",
        "net-position": "Poziția netă:"
    },
    "nl": {
        "ok": "ok",
        "balance": "saldo",
        "win": "winst",
        "bet": "inzet",
        "bet-amount": "Inzethoeveelheid",
        "autoplay": "Autoplay",
        "spins": "spins",
        "sound": "geluid",
        "pricelist": "Prijslijst",
        "game-rules": "spelregels",
        "keyboard": "toetsenbord",
        "paytable": "betalingstabel",
        "history": "spelgeschiedenis",
        "settings": "Instellingen",
        "on": "aan",
        "off": "uit",
        "start": "start",
        "back": "terug",
        "sound-settings": "Geluidsinstellingen",
        "game-volume": "Volume",
        "music": "muziek",
        "sound-effects": "geluidseffecten",
        "date": "datum en tijd",
        "confirm": "bevestig",
        "close-game": "sluit het spel",
        "close": "afsluiten",
        "realityCheckContent": "Je hebt zo veel tijd gespeeld {0}",
        "reality": "realiteitscheck",
        "balanceChange": "saldo verschil",
        "roundId": "ronde ID",
        "loss-limit": "verlieslimiet",
        "single-win-limit": "enkele winst limiet",
        "loss-limit-popup": "Autoplay is gestopt omdat je meer verloor dan het verlieslimiet",
        "win-limit-popup": "Autoplay is gestopt omdat je meer verloor dan het verlieslimiet",
        "paytableTitle": "BETALINGSTABEL",
        "pricelistTitle": "PRIJSLIJST",
        "paylinesTitle": "BETAALLIJNEN",
        "paylinesContent": "De betaaltafel geeft de huidige betaalconfiguratie. Betaallijnen betalen uit van links naar rechts.",
        "allwaysTitle": "WIN OP ALLE MANIEREN",
        "allwaysContent": "Met Win op Alle Manieren, zijn er geen vaste betaallijnen. Symbolen hoeven enkel op naast elkaar gelegen rollen te landen. Winsten per Manier worden berekend op basis van de langste combinatie van links naar rechts.",
        "fun-mode": "SPELEN VOOR FUN",
        "required": "vereist",
        "accept": "aanvaard",
        "reject": "weiger",
        "free-spins": "Free spins",
        "super-free-spins": "Super gratis spins",
        "leave-game": "verlaat spel",
        "relaunch": "herstart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max. winst {1}x",
        "net-position": "Netto positie:"
    },
    "fi": {
        "ok": "ok",
        "balance": "saldo",
        "win": "voitto",
        "bet": "panos",
        "bet-amount": "Panoskoko",
        "autoplay": "Automaattipeli",
        "spins": "pyöräytykset",
        "sound": "äänet",
        "pricelist": "Hinta lista",
        "game-rules": "säännöt",
        "keyboard": "näppäimistö",
        "paytable": "voittotaulu",
        "history": "pelihistoria",
        "settings": "Pelin asetukset",
        "on": "päällä",
        "off": "pois",
        "start": "käynnistä",
        "back": "takaisin",
        "sound-settings": "Äänten asetukset",
        "game-volume": "Äänenvoimakkuus",
        "music": "musiikki",
        "sound-effects": "äänitehosteet",
        "date": "päivämäärä & aika",
        "confirm": "vahvista",
        "close-game": "sulje peli",
        "close": "sulje",
        "realityCheckContent": "Olet pelannut näin kauan {0}",
        "reality": "todellisuus kutsuu",
        "balanceChange": "saldon muutos",
        "roundId": "kierroksen ID",
        "loss-limit": "tappioraja",
        "single-win-limit": "yksittäisen voiton rajoitus",
        "loss-limit-popup": "Automaattipeli pysäytetty tappion ylittäessä tappiorajan",
        "win-limit-popup": "Automaattipeli pysäytetty, koska voitit enemmän kuin yksittäisen voiton raja",
        "paytableTitle": "VOITTOTAULU",
        "pricelistTitle": "HINTA LISTA",
        "paylinesTitle": "VOITTOLINJAT",
        "paylinesContent": "Voittotaulu vastaa tämänhetkistä maksuasetusta. Voittolinjat maksavat vasemmalta oikealle.",
        "allwaysTitle": "KAIKKI VOITTOSUUNNAT",
        "allwaysContent": "Kaikki voittosuunnat tarkoittaa sitä, ettei käytössä ole kiinteitä voittolinjoja - symbolien pitää ainoastaan osua vierekkäisille rullille luodakseen voittoja. Linjan voitot lasketaan pisimmän vasemmalta oikealle ulottuvan yhdistelmän mukaan.",
        "fun-mode": "LEIKKIRAHA-TILA",
        "required": "vaaditaan",
        "accept": "hyväksy",
        "reject": "hylkää",
        "free-spins": "Ilmaiskierrokset",
        "super-free-spins": "Super ilmaiskierrosta",
        "leave-game": "poistu pelistä",
        "relaunch": "käynnistä uudelleen",
        "id": "id",
        "rtp-and-maxwin": "Palautusprosentti {0}%, Maksimivoitto {1}x",
        "net-position": "NET-asema:"
    },
    "no": {
        "ok": "ok",
        "balance": "saldo",
        "win": "gevinst",
        "bet": "innsats",
        "bet-amount": "Innsatsbeløp",
        "autoplay": "Autospill",
        "spins": "spinn",
        "sound": "lyd",
        "pricelist": "Prislista",
        "game-rules": "spillregler",
        "keyboard": "tastatur",
        "paytable": "utbetalingstabell",
        "history": "spillhistorikk",
        "settings": "Innstillinger",
        "on": "på",
        "off": "av",
        "start": "start",
        "back": "tilbake",
        "sound-settings": "Lydinnstillinger",
        "game-volume": "Volum",
        "music": "musikk",
        "sound-effects": "lydeffekter",
        "date": "dato og tid",
        "confirm": "bekreft",
        "close-game": "lukk spillet",
        "close": "lukk",
        "realityCheckContent": "Så lenge har du spilt {0}",
        "reality": "virkelighetskontroll",
        "balanceChange": "saldodifferanse",
        "roundId": "runde-ID",
        "loss-limit": "tapsgrense",
        "single-win-limit": "grense for enkeltgevinst",
        "loss-limit-popup": "Autospill er stanset, da du har tapt mer enn tapsgrensen",
        "win-limit-popup": "Autospill er stanset, da du har vunnet mer enn grensen for enkeltgevinst",
        "paytableTitle": "UTBETALINGSTABELL",
        "pricelistTitle": "PRIS LISTE",
        "paylinesTitle": "INNSATSLINJER",
        "paylinesContent": "Utbetalingstabellen gjenspeiler den gjeldende utbetalingskonfigurasjonen. Innsatslinjer gir gevinst fra venstre mot høyre.",
        "allwaysTitle": "ALLE VEIER",
        "allwaysContent": "Spillet gir gevinst alle veier, og har ingen faste innsatslinjer. Symboler på tilstøtende hjul gir gevinst. Gevinsten per måte å vinne på beregnes basert på den lengste kombinasjonen fra venstre til høyre.",
        "fun-mode": "DEMOMODUS",
        "required": "påkrevd",
        "accept": "godta",
        "reject": "avvis",
        "free-spins": "Free spins",
        "super-free-spins": "Super gratis spinn",
        "leave-game": "avslutt spill",
        "relaunch": "start på nytt",
        "id": "id",
        "rtp-and-maxwin": "RTP {0} %, maksgevinst {1}x",
        "net-position": "Netto posisjon:"
    },
    "da": {
        "ok": "ok",
        "balance": "saldo",
        "win": "gevinst",
        "bet": "indsats",
        "bet-amount": "Indsatsbeløb",
        "autoplay": "Autospil",
        "spins": "spins",
        "sound": "lyd",
        "pricelist": "Prisliste",
        "game-rules": "spilleregler",
        "keyboard": "tastatur",
        "paytable": "gevinsttabel",
        "history": "spilhistorik",
        "settings": "Indstillinger",
        "on": "tændt",
        "off": "slukket",
        "start": "start",
        "back": "tilbage",
        "sound-settings": "Lydindstillinger",
        "game-volume": "Lydstyrke",
        "music": "musik",
        "sound-effects": "lydeffekter",
        "date": "dato & tid",
        "confirm": "bekræft",
        "close-game": "luk spillet",
        "close": "luk",
        "realityCheckContent": "Så længe har du spillet {0}",
        "reality": "reality check",
        "balanceChange": "saldo forskel",
        "roundId": "runde ID",
        "loss-limit": "tabsgrænse",
        "single-win-limit": "single gevinstgrænse",
        "loss-limit-popup": "Autospil stoppede, da du tabte mere end tabsgrænsen",
        "win-limit-popup": "Autospil stoppede, da du vandt mere end gevinstgrænsen",
        "paytableTitle": "GEVINSTTABEL",
        "pricelistTitle": "PRISLISTE",
        "paylinesTitle": "GEVINSTLINJER",
        "paylinesContent": "Gevinststabellen afspejler den nuværende gevinstkonfiguration. Gevinstlinjer giver gevinst fra venstre mod højre.",
        "allwaysTitle": "ALLE VEJE",
        "allwaysContent": "Med Alle Veje er der ingen faste gevinstlinjer - symboler skal bare lande på sammenhængende hjul for at generere gevinster. Gevinster pr Vej beregnes ud fra den længste kombination fra venstre mod højre.",
        "fun-mode": "FUN MODE",
        "required": "påkrævet",
        "accept": "acceptere",
        "reject": "afvis",
        "free-spins": "Free Spins",
        "super-free-spins": "Super gratis spins",
        "leave-game": "forlad spil",
        "relaunch": "genstart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Maks gevinst {1}x",
        "net-position": "Netstilling:"
    },
    "pt": {
        "ok": "ok",
        "balance": "saldo",
        "win": "ganho",
        "bet": "aposta",
        "bet-amount": "Montante da Aposta",
        "autoplay": "Jogo automático",
        "spins": "spins",
        "sound": "som",
        "pricelist": "Lista de preços",
        "game-rules": "regras do jogo",
        "keyboard": "teclado",
        "paytable": "tabela de pagamento",
        "history": "histórico de jogo",
        "settings": "Definições",
        "on": "lig.",
        "off": "desl.",
        "start": "começar",
        "back": "voltar",
        "sound-settings": "Definições de Áudio",
        "game-volume": "Volume",
        "music": "música",
        "sound-effects": "efeitos sonoros",
        "date": "data e hora",
        "confirm": "confirmar",
        "close-game": "fechar o jogo",
        "close": "fechar",
        "realityCheckContent": "Está a jogar há este tempo {0}",
        "reality": "toque de realidade",
        "balanceChange": "diferença de saldo",
        "roundId": "ID da ronda",
        "loss-limit": "limite de perdas",
        "single-win-limit": "limite de ganho único",
        "loss-limit-popup": "O jogo automático parou porque perdeu mais do que o limite de perdas",
        "win-limit-popup": "O jogo automático parou porque ganhou mais do que o limite de ganho único",
        "paytableTitle": "TABELA DE PAGAMENTO",
        "pricelistTitle": "LISTA DE PREÇOS",
        "paylinesTitle": "LINHAS DE PAGAMENTO",
        "paylinesContent": "A tabela de pagamento reflete a configuração de pagamento atual. As linhas de pagamento pagam da esquerda para a direita.",
        "allwaysTitle": "TODAS AS MANEIRAS",
        "allwaysContent": "Com Todas as Maneiras não há linhas de pagamento fixas - os símbolos só precisam de cair em rolos adjacentes para gerar ganhos. Os ganhos são calculados com base na combinação mais longa da esquerda para a direita.",
        "fun-mode": "MODO DE DIVERSÃO",
        "required": "obrigatório",
        "accept": "aceitar",
        "reject": "rejeitar",
        "free-spins": "Free Spins",
        "super-free-spins": "spins Super gratuitos",
        "leave-game": "sair do jogo",
        "relaunch": "reiniciar",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Ganho máx. {1}x",
        "net-position": "Posição de Internet:"
    },
    "pt-br": {
        "ok": "ok",
        "balance": "saldo",
        "win": "ganho",
        "bet": "aposta",
        "bet-amount": "Montante da Aposta",
        "autoplay": "Jogo automático",
        "spins": "spins",
        "sound": "som",
        "pricelist": "Lista de preços",
        "game-rules": "regras do jogo",
        "keyboard": "teclado",
        "paytable": "tabela de pagamento",
        "history": "histórico de jogo",
        "settings": "Definições",
        "on": "lig.",
        "off": "desl.",
        "start": "começar",
        "back": "voltar",
        "sound-settings": "Definições de Áudio",
        "game-volume": "Volume",
        "music": "música",
        "sound-effects": "efeitos sonoros",
        "date": "data e hora",
        "confirm": "confirmar",
        "close-game": "fechar o jogo",
        "close": "fechar",
        "realityCheckContent": "Está a jogar há este tempo {0}",
        "reality": "toque de realidade",
        "balanceChange": "diferença de saldo",
        "roundId": "ID da ronda",
        "loss-limit": "limite de perdas",
        "single-win-limit": "limite de ganho único",
        "loss-limit-popup": "O jogo automático parou porque perdeu mais do que o limite de perdas",
        "win-limit-popup": "O jogo automático parou porque ganhou mais do que o limite de ganho único",
        "paytableTitle": "TABELA DE PAGAMENTO",
        "pricelistTitle": "LISTA DE PREÇOS",
        "paylinesTitle": "LINHAS DE PAGAMENTO",
        "paylinesContent": "A tabela de pagamento reflete a configuração de pagamento atual. As linhas de pagamento pagam da esquerda para a direita.",
        "allwaysTitle": "TODAS AS MANEIRAS",
        "allwaysContent": "Com Todas as Maneiras não há linhas de pagamento fixas - os símbolos só precisam de cair em rolos adjacentes para gerar ganhos. Os ganhos são calculados com base na combinação mais longa da esquerda para a direita.",
        "fun-mode": "MODO DE DIVERSÃO",
        "required": "obrigatório",
        "accept": "aceitar",
        "reject": "rejeitar",
        "free-spins": "Free Spins",
        "super-free-spins": "spins Super gratuitos",
        "leave-game": "sair do jogo",
        "relaunch": "reiniciar",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Ganho máx. {1}x",
        "net-position": "Posição de Internet:"
    },
    "it": {
        "ok": "ok",
        "balance": "saldo",
        "win": "vincita",
        "bet": "puntata",
        "bet-amount": "Importo Puntata",
        "autoplay": "Gioco automatico",
        "spins": "giri",
        "sound": "sonoro",
        "pricelist": "LISTINO PREZZI",
        "game-rules": "regole del gioco",
        "keyboard": "tastiera",
        "paytable": "tabella dei pagamenti",
        "history": "cronologia di gioco",
        "settings": "Impostazioni",
        "on": "on",
        "off": "off",
        "start": "avvia",
        "back": "indietro",
        "sound-settings": "Impostazioni Audio",
        "game-volume": "Volume",
        "music": "musica",
        "sound-effects": "effetti sonori",
        "date": "data e ora",
        "confirm": "conferma",
        "close-game": "chiudi il gioco",
        "close": "chiudi",
        "realityCheckContent": "Stai giocando da {0}",
        "reality": "controllo realtà",
        "balanceChange": "differenza di saldo",
        "roundId": "ID giocata",
        "loss-limit": "limite di perdita",
        "single-win-limit": "limite vincita singola",
        "loss-limit-popup": "Il gioco automatico si è fermato perché hai perso più del limite di perdita",
        "win-limit-popup": "Il gioco automatico si è fermato perché hai vinto più del limite di vincita singola",
        "paytableTitle": "TABELLA DEI PAGAMENTI",
        "pricelistTitle": "LISTINO PREZZI",
        "paylinesTitle": "LINEE DI PAGAMENTO",
        "paylinesContent": "La tabella dei pagamenti riflette l'attuale configurazione dei pagamenti. Le linee di pagamento pagano da sinistra verso destra.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Con All Ways, non ci sono linee di pagamento fisse. I simboli devono solo comparire su rulli consecutivi per generare vincite. Le vincite vengono calcolate in base alla combinazione più lunga di simboli da sinistra a destra.",
        "fun-mode": "GIOCA PER DIVERTIMENTO",
        "required": "necessario",
        "accept": "accetta",
        "reject": "rifiuta",
        "free-spins": "Free Spin",
        "super-free-spins": "giri Super Free",
        "leave-game": "esci dal gioco",
        "relaunch": "ricomincia",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Vincita massima {1}x",
        "net-position": "Posizione netta:"
    },
    "ja": {
        "ok": "オッケー",
        "balance": "残高",
        "win": "勝利",
        "bet": "ベット",
        "bet-amount": "ベットの量",
        "autoplay": "自動プレイ",
        "spins": "スピン",
        "sound": "サウンド",
        "pricelist": "配当表",
        "game-rules": "ゲームルール",
        "keyboard": "キーボード",
        "paytable": "配当表",
        "history": "ゲーム履歴",
        "settings": "ゲーム設定",
        "on": "オン",
        "off": "オフ",
        "start": "開始",
        "back": "戻る",
        "sound-settings": "ゲーム設定",
        "game-volume": "容量",
        "music": "音楽",
        "sound-effects": "効果音",
        "date": "日付 & 時間",
        "confirm": "確認",
        "close-game": "ゲームを閉じる",
        "close": "閉じる",
        "realityCheckContent": "これだけの時間プレイしています {0}",
        "reality": "リアリティチェック",
        "balanceChange": "バランスの差",
        "roundId": "ラウンド ID",
        "loss-limit": "ロスリミット",
        "single-win-limit": "一度の勝利限度額",
        "loss-limit-popup": "ロスリミットより多く負けたのでオートプレイが停止します",
        "win-limit-popup": "一度の勝利限度額より多く勝ったのでオートプレイが停止します",
        "paytableTitle": "配当表",
        "pricelistTitle": "価格表",
        "paylinesTitle": "ペイライン",
        "paylinesContent": "配当表には、現在のペイアウト設定が反映されています。ペイラインは、左から右に発生します。",
        "allwaysTitle": "オールウェイズ",
        "allwaysContent": "オールウェイズでは、固定のペイラインはありません。各シンボルは隣接するリールに登場するだけで配当が発生します。各1ウェイの獲得金は左から右への最長の組み合わせに基づいて計算されます。",
        "fun-mode": "ファンモード",
        "required": "必須",
        "accept": "アクセプト",
        "reject": "拒否",
        "free-spins": "フリースピン",
        "super-free-spins": "スーパーフリースピン",
        "leave-game": "ゲームから退場する",
        "relaunch": "再スタート",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, 最高勝利額 {1}x",
        "net-position": "ネット位置："
    },
    "ru": {
        "ok": "ок",
        "balance": "баланс",
        "win": "выигрыш",
        "bet": "ставка",
        "bet-amount": "Размер ставки",
        "autoplay": "Автоигра",
        "spins": "spins",
        "sound": "звук",
        "pricelist": "ПРАЙС-ЛИСТ",
        "game-rules": "правила игры",
        "keyboard": "клавиатура",
        "paytable": "таблица выплат",
        "history": "история игры",
        "settings": "Настройки",
        "on": "вкл.",
        "off": "выкл.",
        "start": "старт",
        "back": "назад",
        "sound-settings": "Настройки звука",
        "game-volume": "Громкость",
        "music": "музыка",
        "sound-effects": "звуковые эффекты",
        "date": "дата & время",
        "confirm": "подтвердить",
        "close-game": "закрыть игру",
        "close": "закрыть",
        "realityCheckContent": "Вы играли: {0}",
        "reality": "оценка ситуации",
        "balanceChange": "разница баланса",
        "roundId": "ID раунда",
        "loss-limit": "лимит проигрыша",
        "single-win-limit": "лимит одиночного выигрыша",
        "loss-limit-popup": "Автоигра остановится, если вы потратите больше лимита проигрыша",
        "win-limit-popup": "Автоигра остановится, если вы выиграете больше лимита одиночного выигрыша",
        "paytableTitle": "ТАБЛИЦА ВЫПЛАТ",
        "pricelistTitle": "ПРАЙС-ЛИСТ",
        "paylinesTitle": "ВЫИГРЫШНЫЕ ЛИНИИ",
        "paylinesContent": "Таблица выплат отображает текущую конфигурацию выплат. Выигрыши на линиях укладываются слева направо.",
        "allwaysTitle": "ВЫИГРЫШ ВО ВСЕХ НАПРАВЛЕНИЯХ",
        "allwaysContent": "С \\выигрышем во всех направлениях\\\" нет фиксированных выигрышных линий – символам достаточно выпасть на соседних барабанах, чтобы уложить выигрышную комбинацию. Выигрыш в каждой комбинации рассчитывается исходя из самой длинной комбинации слева направо.\"",
        "fun-mode": "ДЕМО-ВЕРСИЯ",
        "required": "необходимо",
        "accept": "принять",
        "reject": "отказаться",
        "free-spins": "Free Spins",
        "super-free-spins": "Супер свободные закрутки",
        "leave-game": "выйти из игры",
        "relaunch": "перезапуск",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, макс. выигрыш {1}x",
        "net-position": "Чистая позиция:"
    },
    "cs": {
        "ok": "OK",
        "balance": "Zůstatek",
        "win": "vyhrát",
        "bet": "sázka",
        "bet-amount": "Sázkové množství",
        "autoplay": "Automatické přehrávání",
        "spins": "spins",
        "sound": "zvuk",
        "pricelist": "Ceník",
        "game-rules": "pravidla hry",
        "keyboard": "klávesnice",
        "paytable": "Platba",
        "history": "Historie Historie",
        "settings": "Nastavení",
        "on": "na",
        "off": "vypnuto",
        "start": "Start",
        "back": "zadní",
        "sound-settings": "Nastavení zvuku",
        "game-volume": "Objem",
        "music": "hudba",
        "sound-effects": "zvukové efekty",
        "date": "čas schůzky",
        "confirm": "potvrdit",
        "close-game": "Zavřete hru",
        "close": "zavřít",
        "realityCheckContent": "Hráli jste toto množství času {0}",
        "reality": "Kontrola reality",
        "balanceChange": "Rozdíl váhy",
        "roundId": "kolo ID",
        "loss-limit": "limit ztráty",
        "single-win-limit": "limit jedné vítězství",
        "loss-limit-popup": "Autoplay se zastavil, když jste ztratili více než limit ztráty",
        "win-limit-popup": "Autoplay se zastavil, když jste vyhráli více než jeden limit víra",
        "paytableTitle": "Platba",
        "pricelistTitle": "CENÍK",
        "paylinesTitle": "Platební linie",
        "paylinesContent": "PAYTEBA odráží aktuální konfiguraci výplaty. Paylines platí zleva doprava.",
        "allwaysTitle": "VŠECHNY CESTY",
        "allwaysContent": "Se všemi způsoby neexistují žádné pevné placené linky - symboly jen potřebují přistát na přilehlých navijáků, aby generoval výhry. Vyhrála na cestu se vypočítají na základě nejdelší kombinace zleva doprava.",
        "fun-mode": "Zábavný režim",
        "required": "Požadované",
        "accept": "přijmout",
        "reject": "odmítnout",
        "free-spins": "Otočení zdarma",
        "super-free-spins": "Super Free Spins.",
        "leave-game": "opustit hru",
        "relaunch": "restart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Maximální výhra {1}x",
        "net-position": "Čistá pozice:"
    },
    "el": {
        "ok": "ok",
        "balance": "υπόλοιπο",
        "win": "win",
        "bet": "bet",
        "bet-amount": "Bet Ποσόν",
        "autoplay": "Autoplay",
        "spins": "spins",
        "sound": "ήχος",
        "pricelist": "Λίστα τιμών",
        "game-rules": "κανόνες παιχνιδιού",
        "keyboard": "πληκτρολόγιο",
        "paytable": "πίνακας πληρωμών",
        "history": "ιστορικό παιχνιδιού",
        "settings": "Ρυθμίσεις",
        "on": "on",
        "off": "off",
        "start": "έναρξη",
        "back": "πίσω",
        "sound-settings": "Ρυθμίσεις Ήχου",
        "game-volume": "Ένταση",
        "music": "μουσική",
        "sound-effects": "ηχητικά εφέ",
        "date": "ημερομηνία & ώρα",
        "confirm": "συνέχεια",
        "close-game": "κλείσιμο παιχνιδιού",
        "close": "κλείσιμο",
        "realityCheckContent": "Παίζεις τόσο χρόνο {0}",
        "reality": "έλεγχος πραγματικότητας",
        "balanceChange": "διαφορά υπολοίπου",
        "roundId": "ID γύρου",
        "loss-limit": "όριο απώλειας",
        "single-win-limit": "Όριο ενός win",
        "loss-limit-popup": "Το autoplay σταμάτησε. Έχασες περισσότερα από το όριο απώλειας",
        "win-limit-popup": "Το autoplay σταμάτησε. Κέρδισες περισσότερα από όριο ενός win",
        "paytableTitle": "ΠΙΝΑΚΑΣ ΠΛΗΡΩΜΩΝ",
        "pricelistTitle": "ΛΙΣΤΑ ΤΙΜΩΝ",
        "paylinesTitle": "ΓΡΑΜΜΕΣ ΠΛΗΡΩΜΗΣ",
        "paylinesContent": "Ο Πίνακας Πληρωμών αντανακλά την τρέχουσα διαμόρφωση πληρωμών. Οι γραμμές πληρωμής (paylines) πληρώνουν από αριστερά προς τα δεξιά.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Με το All Ways (Όλοι οι Τρόποι), δεν υπάρχουν σταθερές γραμμές πληρωμής (pay lines) - τα σύμβολα θα πρέπει απλά να προσγειωθούν σε διαδοχικές στήλες για την παραγωγή wins (κερδών). Τα wins ανά τρόπο υπολογίζονται βάσει του μακρύτερου συνδυασμού από αριστερά προς τα δεξιά.",
        "fun-mode": "FUN ΛΕΙΤΟΥΡΓΙΑ",
        "required": "απαιτείται",
        "accept": "αποδοχή",
        "reject": "απόρριψη",
        "free-spins": "Free Spins",
        "super-free-spins": "Σούπερ δωρεάν περιστροφές",
        "leave-game": "έξοδος παιχνιδιού",
        "relaunch": "επανεκκίνηση",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Μέγιστο win {1}x",
        "net-position": "Καθαρή θέση:"
    },
    "pl": {
        "ok": "ok",
        "balance": "saldo",
        "win": "wygrana",
        "bet": "zakład",
        "bet-amount": "Wysokość zakładu",
        "autoplay": "Automatyczna gra",
        "spins": "zakręcenia",
        "sound": "dźwięk",
        "pricelist": "Cennik",
        "game-rules": "zasady gry",
        "keyboard": "klawiatura",
        "paytable": "tabela wypłat",
        "history": "historia gry",
        "settings": "Ustawienia",
        "on": "wł.",
        "off": "wył.",
        "start": "start",
        "back": "powrót",
        "sound-settings": "Ustawienia dźwięku",
        "game-volume": "Głośność",
        "music": "muzyka",
        "sound-effects": "efekty dźwiękowe",
        "date": "data i godzina",
        "confirm": "potwierdź",
        "close-game": "zamknij grę",
        "close": "zamknij",
        "realityCheckContent": "Grasz przez następującą ilość czasu {0}",
        "reality": "reality check",
        "balanceChange": "różnica salda",
        "roundId": "ID rundy",
        "loss-limit": "limit strat",
        "single-win-limit": "limit pojedynczej wygranej",
        "loss-limit-popup": "Automatyczna gra została zatrzymana, ponieważ przekroczono limit strat",
        "win-limit-popup": "Automatyczna gra została zatrzymana, ponieważ przekroczono limit pojedynczej wygranej",
        "paytableTitle": "TABELA WYPŁAT",
        "pricelistTitle": "CENNIK",
        "paylinesTitle": "LINIE WYPŁAT",
        "paylinesContent": "Tabela wypłat pokazuje aktualne konfiguracje wypłat. Linie wypłat liczone są od lewej do prawej strony.",
        "allwaysTitle": "WSZYSTKIE KOMBINACJE",
        "allwaysContent": "W grze wszystkie kombinacje dają wygraną. Oznacza to, że nie ma stałych linii wypłat. Aby otrzymać wygraną, należy trafić takie same symbole na sąsiadujących rolkach. Wygrane z kombinacji obliczane są na podstawie najdłuższej wygrywającej kombinacji liczonej od lewej do prawej strony.",
        "fun-mode": "TRYB GRY DLA ZABAWY",
        "required": "wymagany",
        "accept": "zaakceptuj",
        "reject": "odrzuć",
        "free-spins": "Free Spins",
        "super-free-spins": "Super darmowe spiny",
        "leave-game": "opuść grę",
        "relaunch": "restart",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Maksymalna wygrana {1}x",
        "net-position": "Pozycja netto:"
    },
    "hu": {
        "ok": "ok",
        "balance": "egyenleg",
        "win": "nyeremény",
        "bet": "tét",
        "bet-amount": "Tét összeg",
        "autoplay": "Automatikus játék",
        "spins": "pörgetések",
        "sound": "hang",
        "pricelist": "Árlista",
        "game-rules": "játékszabályok",
        "keyboard": "billentyűzet",
        "paytable": "nyereménytábla",
        "history": "játékelőzmények",
        "settings": "Játékbeállítások",
        "on": "be",
        "off": "ki",
        "start": "start",
        "back": "vissza",
        "sound-settings": "Hangbeállítások",
        "game-volume": "Hangerő",
        "music": "zene",
        "sound-effects": "hangeffektek",
        "date": "dátum & idő",
        "confirm": "megerősít",
        "close-game": "játék bezárása",
        "close": "bezárás",
        "realityCheckContent": "Ennyi ideje játszol {0}",
        "reality": "realitás ellenőrző",
        "balanceChange": "egyenlegkülönbség",
        "roundId": "forduló ID",
        "loss-limit": "veszteséglimit",
        "single-win-limit": "egyszeri nyeremény limit",
        "loss-limit-popup": "Az Autoplay leáll, amint többet veszítesz, mint a veszteséglimit",
        "win-limit-popup": "Az Autoplay leáll, amint többet nyersz, mint az egyszeri nyeremény limit",
        "paytableTitle": "NYEREMÉNYTÁBLA",
        "pricelistTitle": "ÁRLISTA",
        "paylinesTitle": "NYERŐVONALAK",
        "paylinesContent": "A kifizetési táblázat az aktuális kifizetési konfigurációt mutatja. A Nyerővonalak balról jobbra fizetnek.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Az All Ways-nek köszönhetően, nincsenek fix nyerővonalak - A szimbólumoknak csak a szomszédos tárcsákon kell landolniuk, hogy nyereményeket nyújtsanak. A nyerési módonként szerinti nyeremények kiszámításának alapjául a leghosszabb, balról jobbra elhelyezkedő kombináció szolgál.",
        "fun-mode": "SZÓRAKOZÁSI JÁTÉKMÓD",
        "required": "szükséges",
        "accept": "elfogad",
        "reject": "elvet",
        "free-spins": "Ingyenes Pörgetések",
        "super-free-spins": "Super ingyenes pörgetést",
        "leave-game": "kilépés a játékból",
        "relaunch": "újrakezdés",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max nyeremény {1}x",
        "net-position": "Nettó pozíció:"
    },
    "et": {
        "ok": "ok",
        "balance": "saldo",
        "win": "võit",
        "bet": "panus",
        "bet-amount": "Panuse summa",
        "autoplay": "Automaatmäng",
        "spins": "keerutused",
        "sound": "heli",
        "pricelist": "Hinnakiri",
        "game-rules": "mängureeglid",
        "keyboard": "klaviatuur",
        "paytable": "võidutabel",
        "history": "mängu ajalugu",
        "settings": "Sätted",
        "on": "sees",
        "off": "väljas",
        "start": "start",
        "back": "tagasi",
        "sound-settings": "Helisätted",
        "game-volume": "Helitugevus",
        "music": "muusika",
        "sound-effects": "heliefektid",
        "date": "kuupäev ja aeg",
        "confirm": "kinnita",
        "close-game": "sulge mäng",
        "close": "sulge",
        "realityCheckContent": "Oled mänginud nii pika aja jooksul {0}",
        "reality": "enesekontroll",
        "balanceChange": "saldo erinevus",
        "roundId": "vooru ID",
        "loss-limit": "kaotuselimiit",
        "single-win-limit": "ühe võidu limiit",
        "loss-limit-popup": "Automaatmäng peatus, sest kaotasid rohkem kui on kaotuse limiit",
        "win-limit-popup": "Automaatmäng peatus, sest võitsid rohkem kui on ühe võidu limiit",
        "paytableTitle": "VÕIDUTABEL",
        "pricelistTitle": "HINNAKIRI",
        "paylinesTitle": "VÕIDULIINID",
        "paylinesContent": "Võidutabel kajastab väljamaksete praegust konfiguratsiooni. Võiduliinid maksavad vasakult paremale.",
        "allwaysTitle": "KÕIK LIINID",
        "allwaysContent": "Kõikide liinidega pole fikseeritud võiduliine - võitude loomiseks peavad sümbolid lihtsalt maanduma külgnevatele rullikutele. Võidud võiduliinil arvutatakse pikima kombinatsiooni põhjal vasakult paremale.",
        "fun-mode": "OMA LÕBUKS REŽIIM",
        "required": "nõutud",
        "accept": "nõustu",
        "reject": "keeldu",
        "free-spins": "Tasuta keerutused",
        "super-free-spins": "Super tasuta keerutab",
        "leave-game": "lahku mängust",
        "relaunch": "alusta uuesti",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Max võit {1}x",
        "net-position": "Netopositsioon:"
    },
    "lt": {
        "ok": "gerai",
        "balance": "balansas",
        "win": "laimėti",
        "bet": "statymas",
        "bet-amount": "Statymo Suma",
        "autoplay": "Automatinis paleidimas",
        "spins": "sukimai",
        "sound": "garsas",
        "pricelist": "Kainoraštis",
        "game-rules": "žaidimo taisyklės",
        "keyboard": "klaviatūra",
        "paytable": "mokėjimo lentelė",
        "history": "Žaidimo istorija",
        "settings": "Nustatymai",
        "on": "įjungta",
        "off": "išjungti",
        "start": "pradėti",
        "back": "atgal",
        "sound-settings": "Garso Nustatymai",
        "game-volume": "Garso stiprumas",
        "music": "muzika",
        "sound-effects": "garso efektai",
        "date": "data ir laikas",
        "confirm": "patvirtinti",
        "close-game": "uždaryti žaidimą",
        "close": "uždaryti",
        "realityCheckContent": "Jūs žaidėte tai su laiko suma {0}",
        "reality": "realumo patikrinimas",
        "balanceChange": "balanso skirtumas",
        "roundId": "raundo ID",
        "loss-limit": "praradimo limitas",
        "single-win-limit": "vienos pergalės limitas",
        "loss-limit-popup": "Automatinis paleidimas sustabdytas, nes Jūs praradote daugiau nei praradimo limitas",
        "win-limit-popup": "Automatinis paleidimas sustabdytas, nes Jūs laimėjote daugiau nei atskiro laimėjimo limitas",
        "paytableTitle": "MOKĖJIMO LENTELĖ",
        "pricelistTitle": "KAINORAŠTIS",
        "paylinesTitle": "MOKĖJIMO EILUTĖS",
        "paylinesContent": "Išmokų tabletė parodo dabartinių išmokų konfigūraciją. Mokėjimo eilutės apmoka iš kairės į dešinę.",
        "allwaysTitle": "VISI BŪDAI",
        "allwaysContent": "Su Visais Būdais, nėra fiksuotų mokėjimo eilučių - simboliai tiesiog turi iškristi ant gretimų ričių, kad sukurti laimėjimus. Laimėjimai kelyje yra skaičiuojami remiantis ilgiausia kombinacija iš kairės į dešinę.",
        "fun-mode": "LINKSMAS REŽIMAS",
        "required": "reikia",
        "accept": "priimti",
        "reject": "atmesti",
        "free-spins": "Nemokami Sukimai",
        "super-free-spins": "Super Free Spins",
        "leave-game": "palikti žaidimą",
        "relaunch": "perkrauti",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, Maksimalus laimėjimas {1}x",
        "net-position": "Grynoji pozicija:"
    },
    "tr": {
        "ok": "tamam",
        "balance": "bakiye",
        "win": "kazanç",
        "bet": "bahis",
        "bet-amount": "Bahis Tutar",
        "autoplay": "Otomatik oyun",
        "spins": "spinler",
        "sound": "ses",
        "pricelist": "Fiyat listesi",
        "game-rules": "oyun kuralları",
        "keyboard": "klavye",
        "paytable": "ödeme tablosu",
        "history": "oyun geçmişi",
        "settings": "Oyun ayarları",
        "on": "açık",
        "off": "kapalı",
        "start": "başlat",
        "back": "geri",
        "sound-settings": "Ses ayarları",
        "game-volume": "Ses",
        "music": "müzik",
        "sound-effects": "ses efektleri",
        "date": "tarih ve saat",
        "confirm": "onayla",
        "close-game": "oyunu kapat",
        "close": "kapat",
        "realityCheckContent": "Şu süredir oynuyorsunuz {0}",
        "reality": "gerçeklik kontrolü",
        "balanceChange": "bakiye farkı",
        "roundId": "tur kimliği",
        "loss-limit": "kayıp limiti",
        "single-win-limit": "tek seferde kazanç limiti",
        "loss-limit-popup": "Kayıp limitinden fazla kaybettiğiniz için otomatik oyun durdu",
        "win-limit-popup": "Tek seferde kazanç limitinden fazla kazandığınız için otomatik oyun durdu",
        "paytableTitle": "ÖDEME TABLOSU",
        "pricelistTitle": "FİYAT LİSTESİ",
        "paylinesTitle": "ÖDEME HATLARI",
        "paylinesContent": "Ödeme tablosu mevcut ödeme konfigürasyonunu yansıtır. Ödeme hatları soldan sağa öderler.",
        "allwaysTitle": "TÜM YOLLAR",
        "allwaysContent": "Tüm Yollar ile sabit ödeme hattı yoktur. Kazanç oluşturmak için sembollerin ardışık çarklara gelmesi yeterlidir. Kazançlar, soldan sağa en uzun kombinasyona göre hesaplanır.",
        "fun-mode": "EĞLENCE MODU",
        "required": "gerekli",
        "accept": "kabul et",
        "reject": "reddet",
        "free-spins": "Free Spinler",
        "super-free-spins": "Süper ücretsiz döndürme",
        "leave-game": "oyundan çık",
        "relaunch": "yeniden başla",
        "id": "kimlik",
        "rtp-and-maxwin": "ODO %{0}, Maksimum kazanç {1}x",
        "net-position": "Net konum:"
    },
    "fr": {
        "ok": "ok",
        "balance": "solde",
        "win": "gain",
        "bet": "mise",
        "bet-amount": "Montant de la mise",
        "autoplay": "Jeu automatique",
        "spins": "tours",
        "sound": "son",
        "pricelist": "Liste de prix",
        "game-rules": "règles du jeu",
        "keyboard": "clavier",
        "paytable": "tableau de paiement",
        "history": "historique de jeu",
        "settings": "Paramètres du jeu",
        "on": "allumé",
        "off": "éteint",
        "start": "démarrer",
        "back": "retour",
        "sound-settings": "Paramètres de jeu",
        "game-volume": "Volume",
        "music": "musique",
        "sound-effects": "effets sonores",
        "date": "date et heure",
        "confirm": "confirmer",
        "close-game": "fermer le jeu",
        "close": "fermer",
        "realityCheckContent": "Vous avez joué pendant ce laps de temps {0}",
        "reality": "controle de réalité",
        "balanceChange": "différence de solde",
        "roundId": "ID du tour",
        "loss-limit": "limite de perte",
        "single-win-limit": "limite de gain unique",
        "loss-limit-popup": "Le jeu automatique s'est arrêté car les pertes ont dépassé la limite fixée",
        "win-limit-popup": "Le jeu automatique s'est arrêté car vous avez gagné plus que la limite par gain unique fixée",
        "paytableTitle": "TABLEAU DE PAIEMENT",
        "pricelistTitle": "LISTE DE PRIX",
        "paylinesTitle": "LIGNES DE PAIEMENT",
        "paylinesContent": "Le tableau des paiements correspond à la configuration actuelle des gains potentiels. Les lignes de paiement payent de la gauche vers la droite.",
        "allwaysTitle": "ALL WAYS",
        "allwaysContent": "Avec le système de All Ways, il n'y a pas de lignes de paiement fixes - les symboles doivent juste être obtenus sur des rouleaux adjacents pour générer des gains. Les gains par voie (ways) sont calculés en fonction de la combinaison de gauche à droite la plus longue.",
        "fun-mode": "MODE FUN",
        "required": "requis",
        "accept": "accepter",
        "reject": "rejeter",
        "free-spins": "Tours Gratuits",
        "super-free-spins": "Super tours gratuits",
        "leave-game": "quitter le jeu",
        "relaunch": "redémarrer",
        "id": "id",
        "rtp-and-maxwin": "TRJ {0}%, Gain maximal {1}x",
        "net-position": "La position nette:"
    },
    "bg": {
        "ok": "ок",
        "balance": "баланс",
        "win": "печалба",
        "bet": "залог",
        "bet-amount": "Стойност на Залога",
        "autoplay": "Автоигра",
        "spins": "завъртания",
        "sound": "звук",
        "pricelist": "Ценова листа",
        "game-rules": "правила на играта",
        "keyboard": "клавиатура",
        "paytable": "таблица за изплащане",
        "history": "хронология на играта",
        "settings": "Настройки",
        "on": "включено",
        "off": "изключено",
        "start": "старт",
        "back": "назад",
        "sound-settings": "Настройки на Звука",
        "game-volume": "Звук",
        "music": "музика",
        "sound-effects": "звукови ефекти",
        "date": "дата и време",
        "confirm": "потвърди",
        "close-game": "затваряне на играта",
        "close": "затваряне",
        "realityCheckContent": "Играли сте толкова време {0}",
        "reality": "проверка на състояние",
        "balanceChange": "разлика в баланса",
        "roundId": "ИН на ниво",
        "loss-limit": "лимит на загуба",
        "single-win-limit": "лимит за единична печалба",
        "loss-limit-popup": "Автоиграта бе спряна, понеже загубихте повече от лимита на загуба",
        "win-limit-popup": "Автоиграта бе спряна, понеже спечелихте повече от лимита за единична печалба",
        "paytableTitle": "ТАБЛИЦА ЗА ЗАПЛАЩАНЕ",
        "pricelistTitle": "ЦЕНОВА ЛИСТА",
        "paylinesTitle": "ПЕЧЕЛИВШИ ЛИНИИ",
        "paylinesContent": "Таблицата за изплащане отразява текущата конфигурация на изплащанията. Печелившите линии изплащат отляво надясно.",
        "allwaysTitle": "ВСИЧКИ НАЧИНИ",
        "allwaysContent": "При Всички Начини, няма фиксирани линии за изплащане - символите трябва само да попаднат на съседни барабани, за да генерират печалби. Печалби по Начин се изчисляват на базата на най-дългата комбинация от ляво на дясно.",
        "fun-mode": "ЗАБАВЕН РЕЖИМ",
        "required": "необходимо",
        "accept": "приемане",
        "reject": "отказ",
        "free-spins": "Безплатни завъртания",
        "super-free-spins": "Супер безплатни завъртания",
        "leave-game": "напускане на играта",
        "relaunch": "презапочване",
        "id": "ин",
        "rtp-and-maxwin": "ВКИ {0}%, Макс. печалба {1}x",
        "net-position": "Нетна позиция:"
    },
    "lv": {
        "ok": "labi",
        "balance": "bilance",
        "win": "laimests",
        "bet": "likme",
        "bet-amount": "Likmes apmērs",
        "autoplay": "Automātiska spēle",
        "spins": "griezieni",
        "sound": "skaņa",
        "pricelist": "Cenrādis",
        "game-rules": "spēles noteikumi",
        "keyboard": "tastatūra",
        "paytable": "laimestu tabula",
        "history": "spēles vēsture",
        "settings": "Iestatījumi",
        "on": "ieslēgta",
        "off": "izslēgta",
        "start": "sākts",
        "back": "atpakaļ",
        "sound-settings": "Skaņu iestatījumi",
        "game-volume": "Skaļums",
        "music": "mūzika",
        "sound-effects": "skaņas efekti",
        "date": "datums un laiks",
        "confirm": "apstiprināt",
        "close-game": "aizvērt spēli",
        "close": "aizvērt",
        "realityCheckContent": "Jūs esat spēlējis šādu laika apmēru {0}",
        "reality": "spēlē pavadītais laiks",
        "balanceChange": "bilances starpība",
        "roundId": "raunda ID",
        "loss-limit": "zaudējumu limits",
        "single-win-limit": "viena laimesta limits",
        "loss-limit-popup": "Automātiskā spēle tika apturēta, jo jūs zaudējāt vairāk par noteikto zaudējumu limitu",
        "win-limit-popup": "Automātiskā spēle tika apturēta, jo jūs laimējāt vairāk par noteikto viena laimesta limitu",
        "paytableTitle": "LAIMESTU TABULA",
        "pricelistTitle": "CENRĀDIS",
        "paylinesTitle": "LAIMESTU LĪNIJAS",
        "paylinesContent": "Laimestu tabulā ir norādīta esošā izmaksu konfigurācija. Laimestu līnijas laimestu piešķir no kreisās uz labo pusi.",
        "allwaysTitle": "VISI VARIANTI",
        "allwaysContent": "Visu variantu gadījumā nav nevienas fiksētas laimestu līnijas - lai piešķirtu laimestu, simboliem ir jānolaižas uz blakus esošām spolēm. Varianta laimesti tiek aprēķināti, ņemot vērā garāko kombināciju no kreisās uz labo pusi.",
        "fun-mode": "REŽĪMS \\SPĒLE BEZ MAKSAS SAVAM PRIEKAM\\\"\"",
        "required": "nepieciešams",
        "accept": "pieņemt",
        "reject": "noraidīt",
        "free-spins": "Bezmaksas griezieni",
        "super-free-spins": "Super bezmaksas griezieni",
        "leave-game": "iziet no spēles",
        "relaunch": "restartēt",
        "id": "id",
        "rtp-and-maxwin": "RTP {0}%, maks. laimests {1}x",
        "net-position": "Neto pozīcija:"
    },
    "sr": {
        "ok": "У реду",
        "balance": "равнотежа",
        "win": "победити",
        "bet": "опклада",
        "bet-amount": "Износ клађења",
        "autoplay": "Аутоматско покретање",
        "spins": "спонзити",
        "sound": "звук",
        "pricelist": "Ценовник",
        "game-rules": "правила игре",
        "keyboard": "тастатура",
        "paytable": "плата",
        "history": "историја игре",
        "settings": "Подешавања",
        "on": "на",
        "off": "ван",
        "start": "почетак",
        "back": "назад",
        "sound-settings": "Подешавања звука",
        "game-volume": "Запремина",
        "music": "музика",
        "sound-effects": "звучни ефекти",
        "date": "Датум време",
        "confirm": "Потврди",
        "close-game": "Затвори игру",
        "close": "Близу",
        "realityCheckContent": "Играли сте овај начин {0}",
        "reality": "провера стварности",
        "balanceChange": "разлика у равнотежи",
        "roundId": "округла ид",
        "loss-limit": "лимит за губитак",
        "single-win-limit": "граница појединачне вин",
        "loss-limit-popup": "Аутоматска опрема је заустављена док сте изгубили више од ограничења губитка",
        "win-limit-popup": "АутоПлаи се зауставио док сте освојили више од јединствене вин лимит",
        "paytableTitle": "Плата",
        "pricelistTitle": "ЦЕНОВНИК",
        "paylinesTitle": "Платне линије",
        "paylinesContent": "ПаиТабле одражава конфигурацију тренутне исплате. Паилинес плаћају лево на десно.",
        "allwaysTitle": "СВИ ПУТЕВИ",
        "allwaysContent": "Уз све начине, не постоје фиксне линије за плаће - симболи само треба да слете на суседне колуте за генерисање победа. Потјењали су се по начину израчунате на основу најдуже комбинације са леве на десно.",
        "fun-mode": "Фун Моде",
        "required": "потребан",
        "accept": "прихватити",
        "reject": "одбити",
        "free-spins": "Бесплатни спинови",
        "super-free-spins": "Супер бесплатни спинови",
        "leave-game": "оставити игру",
        "relaunch": "поново покренути",
        "id": "id",
        "rtp-and-maxwin": "РТП {0}%, максимални добитак {1}x",
        "net-position": "Нето позиција:"
    }
}
